module.exports = __webpack_public_path__ + "static/media/icon_cashflow.1c9594e9.svg";